/** The roster/wages switch, and — on the roster only — the name search. */
import { FileText, Search, Users } from 'lucide-react';

export type StaffTab = 'roster' | 'wages';

const BASE = 'flex items-center gap-1.5 px-3 py-2 text-sm';
const IDLE =
  'bg-white dark:bg-[#1a1f1c] text-stone-600 dark:text-stone-400 hover:bg-stone-50 dark:hover:bg-[#242d28]';

export default function StaffTabBar({
  activeTab,
  onTabChange,
  searchTerm,
  onSearchChange,
}: {
  activeTab: StaffTab;
  onTabChange: (tab: StaffTab) => void;
  searchTerm: string;
  onSearchChange: (next: string) => void;
}) {
  const cls = (tab: StaffTab) => `${BASE} ${activeTab === tab ? 'bg-moss-600 text-white' : IDLE}`;
  return (
    <div className="bg-white dark:bg-[#1a1f1c] rounded-lg border mb-6">
      <div className="p-4 border-b flex items-center gap-4">
        <div className="flex items-center border rounded-lg overflow-hidden">
          <button onClick={() => onTabChange('roster')} className={cls('roster')}>
            <Users size={16} />
            Staff &amp; Rates
          </button>
          <button onClick={() => onTabChange('wages')} className={cls('wages')}>
            <FileText size={16} />
            Wage Report
          </button>
        </div>
        {activeTab === 'roster' && (
          <div className="relative flex-1 max-w-md">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" size={18} />
            <input
              type="text"
              placeholder="Search staff..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-moss-500 dark:bg-[#1e2520] dark:text-[#e8ece9]"
            />
          </div>
        )}
      </div>
    </div>
  );
}
